import {getPath} from '@epic-core/common';
import React from 'react';
import {Redirect} from './Redirect';
import {ServerRoute} from './routes';

const StatusRedirect = (): JSX.Element => {
    return <Redirect url="https://status.epicgames.com" status={301} />;
};
const FanArtRedirect = (): JSX.Element => {
    return (
        <Redirect url="https://legal.epicgames.com/:locale/epicgames/fan-art-policy" status={301} />
    );
};
const CustomerSupportRedirect = (): JSX.Element => {
    return <Redirect to="/customer-service" status={301} />;
};
const AboutRedirect = (): JSX.Element => {
    return <Redirect to="/about" status={301} />;
};

export const getAppRedirects = (): ServerRoute[] => {
    const path = getPath();

    return [
        {
            path: `${path}:locale`,
            element: <Redirect to="/home" status={301} />
        },
        {
            path: `${path}:locale/feed`,
            element: <Redirect to="/news" status={301} />
        },
        {
            path: `${path}:locale/feed/news`,
            element: <Redirect to="/news" status={301} />
        },
        {
            path: `${path}:locale/fortnite-mega-drop-faq`,
            element: <Redirect to="/free-fortnite-faq" status={301} />
        },
        {
            path: `${path}:locale/status`,
            element: <StatusRedirect />
        },
        {
            path: `${path}/status`,
            element: <StatusRedirect />
        },
        {
            path: `${path}:locale/about/fan-site-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${path}:locale/fan-site-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${path}:locale/about/fan-art-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${path}:locale/help`,
            element: <CustomerSupportRedirect />
        },
        {
            path: `${path}:locale/account-help`,
            element: <CustomerSupportRedirect />
        },
        {
            path: `${path}:locale/account-security`,
            element: (
                <Redirect
                    url="https://safety.epicgames.com/:locale/policies/account-security"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/about/faq`,
            element: <AboutRedirect />
        },
        {
            path: `${path}:locale/about/contact`,
            element: <AboutRedirect />
        },
        {
            path: `${path}:locale/community`,
            element: <Redirect to="/home" status={301} />
        },
        {
            path: `${path}:locale/freefortnite-uk`,
            element: <Redirect to="/freefortnite-uk-press-release" status={301} />
        },
        {
            path: `${path}:locale/epic-rewards-faq`,
            element: (
                <Redirect url="https://store.epicgames.com/features/epic-rewards" status={301} />
            )
        },
        {
            path: `${path}:locale/students`,
            element: <Redirect to="/earlycareers" status={301} />
        },
        {
            path: `${path}:locale/students/career-paths`,
            element: <Redirect to="/earlycareers/career-paths" status={301} />
        },
        {
            path: `${path}:locale/parental-controls`,
            element: <Redirect url="https://safety.epicgames.com/parental-controls" status={302} />
        },
        {
            path: `${path}:locale/usk-imprint`,
            element: <Redirect to="/impressum" status={301} />
        },
        {
            path: `${path}:locale/wallet-faq`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-faq"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/account-balance-faq`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-faq"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/community-rules`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/community-rules"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/marketplace-disclosure-requirements`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/marketplace-disclosure-requirements"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/parental-consent`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/parental-consent"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/privacynotice`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/privacy-policy"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/privacypolicy`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/privacy-policy"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/fan-art-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${path}:locale/content-guidelines`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/content-guidelines"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/right-of-withdrawal`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/right-of-withdrawal"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/tos`,
            element: (
                <Redirect url="https://legal.epicgames.com/:locale/epicgames/tos" status={301} />
            )
        },
        {
            path: `${path}:locale/tou`,
            element: (
                <Redirect url="https://legal.epicgames.com/:locale/epicgames/tos" status={301} />
            )
        },
        {
            path: `${path}:locale/store-refund-policy`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/store/refund-policy"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/wallet-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-terms"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/account-balance-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-terms"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/giftcardterms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/gift-card-terms"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/gift-card-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/gift-card-terms"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/payments-act`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/ja/epicgames/payments-act"
                    status={301}
                />
            )
        },
        {
            path: `${path}:locale/authenticator`,
            element: <Redirect url="https://store.epicgames.com/:locale/mobile" status={301} />
        }
    ];
};
